import { render, staticRenderFns } from "./PmtaServer.vue?vue&type=template&id=2f95f9cd&scoped=true"
import script from "./PmtaServer.vue?vue&type=script&lang=js"
export * from "./PmtaServer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f95f9cd",
  null
  
)

export default component.exports